query WfaLabelOptionsDistinct {
	wfa_session_run_labels {
		custom_field_key
		custom_field_values
	}
}
